export const AI_PROVIDERS = {
  ANTHROPIC: 'anthropic',
  OPENAI: 'openai',
  GROK: 'grok',
  GEMINI: 'gemini',
  CLOUDFLARE: 'cloudflare',
  MISTRAL: 'mistral',
  DEEPSEEK: 'deepseek',
  ZAI: 'zai'
} as const;

export const PROVIDER_MODELS = {
  [AI_PROVIDERS.ANTHROPIC]: {
    'claude-octopus-4-5-20251101': 'Claude 4.5 Octopus',
    'claude-opus-4-5-20251101': 'Claude 4.5 Opus',
    'claude-opus-4-20250514': 'Claude 4 Opus',
    'claude-sonnet-4-20250514': 'Claude 4 Sonnet',
    'claude-3-5-sonnet-20241022': 'Claude 3.5 Sonnet',
  },
  [AI_PROVIDERS.OPENAI]: {
    'gpt-5.2': 'GPT-5.2',
    'gpt-5.2-pro': 'GPT-5.2 Pro',
    'gpt-5.1': 'GPT-5.1',
    'o3-mini': 'o3-mini',
    'o3': 'o3',
    'gpt-4o': 'GPT-4o',
    'gpt-4o-mini': 'GPT-4o Mini',
    'gpt-4': 'GPT-4',
    'gpt-3.5-turbo': 'GPT-3.5 Turbo'
  },
  [AI_PROVIDERS.GROK]: {
    'grok-4.1': 'Grok 4.1',
    'grok-beta': 'Grok Beta',
    'grok-2-1212': 'Grok 2',
    'grok-2-vision-1212': 'Grok 2 Vision'
  },
  [AI_PROVIDERS.GEMINI]: {
    'gemini-3.0-pro': 'Gemini 3.0 Pro',
    'gemini-3.0': 'Gemini 3.0',
    'gemini-1.5-flash': 'Gemini 1.5 Flash',
    'gemini-1.5-pro': 'Gemini 1.5 Pro',
    'gemini-pro': 'Gemini Pro (Deprecated)',
    'gemini-pro-vision': 'Gemini Pro Vision (Deprecated)'
  },
  [AI_PROVIDERS.CLOUDFLARE]: {
    '@cf/meta/llama-3.1-8b-instruct': 'Llama 3.1 8B Instruct',
    '@cf/meta/llama-2-7b-chat-int8': 'Llama 2 7B Chat',
    '@cf/mistral/mistral-7b-instruct-v0.1': 'Mistral 7B Instruct',
    '@cf/microsoft/phi-2': 'Microsoft Phi-2',
    '@cf/qwen/qwen1.5-7b-chat-awq': 'Qwen 1.5 7B Chat',
    '@cf/google/gemma-2b-it': 'Gemma 2B IT',
    '@cf/meta/llama-4-scout-17b-16e-instruct': 'Llama 4 Scout 17B (Multimodal)',
    '@cf/google/gemma-3-12b-it': 'Gemma 3 12B (Multimodal, 80K context)',
    '@cf/mistral-small-3.1-24b-instruct': 'Mistral Small 3.1 24B (Vision, 128K context)',
    '@cf/meta/llama-3.2-11b-vision-instruct': 'Llama 3.2 11B Vision Instruct'
  },
  [AI_PROVIDERS.MISTRAL]: {
    'mistral-ocr-latest': 'Mistral OCR (Document Understanding)',
    'mistral-medium-3.1': 'Mistral Medium 3.1',
    'ministral-3': 'Ministral 3',
    'devstral-2': 'Devstral 2',
    'mistral-tiny': 'Mistral Tiny',
    'mistral-small': 'Mistral Small',
    'mistral-medium': 'Mistral Medium',
    'mistral-large-latest': 'Mistral Large',
    'mixtral-8x7b-instruct': 'Mixtral 8×7B Instruct'
  },
  [AI_PROVIDERS.DEEPSEEK]: {
    'deepseek-vision': 'DeepSeek Vision (VL)',
    'deepseek-v3.2': 'DeepSeek V3.2',
    'deepseek-chat': 'DeepSeek Chat',
    'deepseek-coder': 'DeepSeek Coder',
    'deepseek-r1': 'DeepSeek-R1',
    'deepseek-reasoner': 'DeepSeek Reasoner',
    'deepseek-r1-distill-qwen-32b': 'DeepSeek R1 Distill Qwen 32B',
    'deepseek-r1-distill-qwen-14b': 'DeepSeek R1 Distill Qwen 14B',
    'deepseek-r1-distill-qwen-7b': 'DeepSeek R1 Distill Qwen 7B',
    'deepseek-r1-distill-llama-70b': 'DeepSeek R1 Distill Llama 70B',
    'deepseek-r1-lite-preview': 'DeepSeek R1 Lite Preview'
  },
  [AI_PROVIDERS.ZAI]: {
    'glm-4.7': 'GLM-4.7 (Flagship)',
    'glm-4.6v': 'GLM-4.6V (Multimodal)',
    'glm-4-plus': 'GLM-4 Plus',
    'glm-4-air': 'GLM-4 Air (Fast)',
    'glm-4-airx': 'GLM-4 AirX (Balanced)',
    'glm-4-flash': 'GLM-4 Flash (Efficient)'
  }
} as const;

export const DEFAULT_AI_PROVIDERS = {
  [AI_PROVIDERS.ANTHROPIC]: 'claude-3-5-sonnet-20241022',
  [AI_PROVIDERS.OPENAI]: 'gpt-3.5-turbo',
  [AI_PROVIDERS.GROK]: 'grok-2-1212',
  [AI_PROVIDERS.GEMINI]: 'gemini-1.5-flash',
  [AI_PROVIDERS.CLOUDFLARE]: '@cf/meta/llama-3.1-8b-instruct',
  [AI_PROVIDERS.MISTRAL]: 'mistral-small',
  [AI_PROVIDERS.DEEPSEEK]: 'deepseek-chat',
  [AI_PROVIDERS.ZAI]: 'glm-4.7'
} as const;

export const PROVIDER_DISPLAY_NAMES = {
  [AI_PROVIDERS.ANTHROPIC]: 'Anthropic Claude',
  [AI_PROVIDERS.OPENAI]: 'OpenAI GPT',
  [AI_PROVIDERS.GROK]: 'xAI Grok',
  [AI_PROVIDERS.GEMINI]: 'Google Gemini',
  [AI_PROVIDERS.CLOUDFLARE]: 'Cloudflare AI',
  [AI_PROVIDERS.MISTRAL]: 'Mistral AI',
  [AI_PROVIDERS.DEEPSEEK]: 'DeepSeek AI',
  [AI_PROVIDERS.ZAI]: 'Z.AI GLM'
} as const;

export type AIProviderType = typeof AI_PROVIDERS[keyof typeof AI_PROVIDERS];
export type AIModelType = string;

export function getModelsForProvider(provider: AIProviderType): Record<string, string> {
  return PROVIDER_MODELS[provider] || {};
}

export function getDefaultModelForProvider(provider: AIProviderType): string {
  return DEFAULT_AI_PROVIDERS[provider] || Object.keys(PROVIDER_MODELS[provider] || {})[0] || '';
}

export function getProviderDisplayName(provider: AIProviderType): string {
  return PROVIDER_DISPLAY_NAMES[provider] || provider;
}

export function getModelDisplayName(modelId: string): string {
  // Search through all providers to find the model name
  for (const provider of Object.keys(PROVIDER_MODELS)) {
    const models = PROVIDER_MODELS[provider as AIProviderType];
    if (models && models[modelId]) {
      return models[modelId];
    }
  }
  // If not found, return the model ID as-is
  return modelId;
}